/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "hu": {
        "nu": ["latn"],
        "year": {
          "0": "ez az év",
          "1": "következő év",
          "future": {
            "one": "{0} év múlva",
            "other": "{0} év múlva"
          },
          "past": {
            "one": "{0} évvel ezelőtt",
            "other": "{0} évvel ezelőtt"
          },
          "-1": "előző év"
        },
        "year-short": {
          "0": "ez az év",
          "1": "következő év",
          "future": {
            "one": "{0} év múlva",
            "other": "{0} év múlva"
          },
          "past": {
            "one": "{0} évvel ezelőtt",
            "other": "{0} évvel ezelőtt"
          },
          "-1": "előző év"
        },
        "year-narrow": {
          "0": "ez az év",
          "1": "következő év",
          "future": {
            "one": "{0} év múlva",
            "other": "{0} év múlva"
          },
          "past": {
            "one": "{0} évvel ezelőtt",
            "other": "{0} évvel ezelőtt"
          },
          "-1": "előző év"
        },
        "quarter": {
          "0": "ez a negyedév",
          "1": "következő negyedév",
          "future": {
            "one": "{0} negyedév múlva",
            "other": "{0} negyedév múlva"
          },
          "past": {
            "one": "{0} negyedévvel ezelőtt",
            "other": "{0} negyedévvel ezelőtt"
          },
          "-1": "előző negyedév"
        },
        "quarter-short": {
          "0": "ez a negyedév",
          "1": "következő negyedév",
          "future": {
            "one": "{0} negyedév múlva",
            "other": "{0} negyedév múlva"
          },
          "past": {
            "one": "{0} negyedévvel ezelőtt",
            "other": "{0} negyedévvel ezelőtt"
          },
          "-1": "előző negyedév"
        },
        "quarter-narrow": {
          "0": "ez a negyedév",
          "1": "következő negyedév",
          "future": {
            "one": "{0} n.év múlva",
            "other": "{0} n.év múlva"
          },
          "past": {
            "one": "{0} negyedévvel ezelőtt",
            "other": "{0} negyedévvel ezelőtt"
          },
          "-1": "előző negyedév"
        },
        "month": {
          "0": "ez a hónap",
          "1": "következő hónap",
          "future": {
            "one": "{0} hónap múlva",
            "other": "{0} hónap múlva"
          },
          "past": {
            "one": "{0} hónappal ezelőtt",
            "other": "{0} hónappal ezelőtt"
          },
          "-1": "előző hónap"
        },
        "month-short": {
          "0": "ez a hónap",
          "1": "következő hónap",
          "future": {
            "one": "{0} hónap múlva",
            "other": "{0} hónap múlva"
          },
          "past": {
            "one": "{0} hónappal ezelőtt",
            "other": "{0} hónappal ezelőtt"
          },
          "-1": "előző hónap"
        },
        "month-narrow": {
          "0": "ez a hónap",
          "1": "következő hónap",
          "future": {
            "one": "{0} hónap múlva",
            "other": "{0} hónap múlva"
          },
          "past": {
            "one": "{0} hónappal ezelőtt",
            "other": "{0} hónappal ezelőtt"
          },
          "-1": "előző hónap"
        },
        "week": {
          "0": "ez a hét",
          "1": "következő hét",
          "future": {
            "one": "{0} hét múlva",
            "other": "{0} hét múlva"
          },
          "past": {
            "one": "{0} héttel ezelőtt",
            "other": "{0} héttel ezelőtt"
          },
          "-1": "előző hét"
        },
        "week-short": {
          "0": "ez a hét",
          "1": "következő hét",
          "future": {
            "one": "{0} hét múlva",
            "other": "{0} hét múlva"
          },
          "past": {
            "one": "{0} héttel ezelőtt",
            "other": "{0} héttel ezelőtt"
          },
          "-1": "előző hét"
        },
        "week-narrow": {
          "0": "ez a hét",
          "1": "következő hét",
          "future": {
            "one": "{0} hét múlva",
            "other": "{0} hét múlva"
          },
          "past": {
            "one": "{0} héttel ezelőtt",
            "other": "{0} héttel ezelőtt"
          },
          "-1": "előző hét"
        },
        "day": {
          "0": "ma",
          "1": "holnap",
          "2": "holnapután",
          "future": {
            "one": "{0} nap múlva",
            "other": "{0} nap múlva"
          },
          "past": {
            "one": "{0} nappal ezelőtt",
            "other": "{0} nappal ezelőtt"
          },
          "-2": "tegnapelőtt",
          "-1": "tegnap"
        },
        "day-short": {
          "0": "ma",
          "1": "holnap",
          "2": "holnapután",
          "future": {
            "one": "{0} nap múlva",
            "other": "{0} nap múlva"
          },
          "past": {
            "one": "{0} napja",
            "other": "{0} napja"
          },
          "-2": "tegnapelőtt",
          "-1": "tegnap"
        },
        "day-narrow": {
          "0": "ma",
          "1": "holnap",
          "2": "holnapután",
          "future": {
            "one": "{0} nap múlva",
            "other": "{0} nap múlva"
          },
          "past": {
            "one": "{0} napja",
            "other": "{0} napja"
          },
          "-2": "tegnapelőtt",
          "-1": "tegnap"
        },
        "hour": {
          "0": "ebben az órában",
          "future": {
            "one": "{0} óra múlva",
            "other": "{0} óra múlva"
          },
          "past": {
            "one": "{0} órával ezelőtt",
            "other": "{0} órával ezelőtt"
          }
        },
        "hour-short": {
          "0": "ebben az órában",
          "future": {
            "one": "{0} óra múlva",
            "other": "{0} óra múlva"
          },
          "past": {
            "one": "{0} órával ezelőtt",
            "other": "{0} órával ezelőtt"
          }
        },
        "hour-narrow": {
          "0": "ebben az órában",
          "future": {
            "one": "{0} óra múlva",
            "other": "{0} óra múlva"
          },
          "past": {
            "one": "{0} órával ezelőtt",
            "other": "{0} órával ezelőtt"
          }
        },
        "minute": {
          "0": "ebben a percben",
          "future": {
            "one": "{0} perc múlva",
            "other": "{0} perc múlva"
          },
          "past": {
            "one": "{0} perccel ezelőtt",
            "other": "{0} perccel ezelőtt"
          }
        },
        "minute-short": {
          "0": "ebben a percben",
          "future": {
            "one": "{0} perc múlva",
            "other": "{0} perc múlva"
          },
          "past": {
            "one": "{0} perccel ezelőtt",
            "other": "{0} perccel ezelőtt"
          }
        },
        "minute-narrow": {
          "0": "ebben a percben",
          "future": {
            "one": "{0} perc múlva",
            "other": "{0} perc múlva"
          },
          "past": {
            "one": "{0} perccel ezelőtt",
            "other": "{0} perccel ezelőtt"
          }
        },
        "second": {
          "0": "most",
          "future": {
            "one": "{0} másodperc múlva",
            "other": "{0} másodperc múlva"
          },
          "past": {
            "one": "{0} másodperccel ezelőtt",
            "other": "{0} másodperccel ezelőtt"
          }
        },
        "second-short": {
          "0": "most",
          "future": {
            "one": "{0} másodperc múlva",
            "other": "{0} másodperc múlva"
          },
          "past": {
            "one": "{0} másodperccel ezelőtt",
            "other": "{0} másodperccel ezelőtt"
          }
        },
        "second-narrow": {
          "0": "most",
          "future": {
            "one": "{0} másodperc múlva",
            "other": "{0} másodperc múlva"
          },
          "past": {
            "one": "{0} másodperccel ezelőtt",
            "other": "{0} másodperccel ezelőtt"
          }
        }
      }
    },
    "availableLocales": ["hu"]
  });
}